import { useFrame } from "@react-three/fiber";
import React, { memo, useRef } from "react";
import { Vector3, type Mesh } from "three";

export const ProductStackTile = memo(function ProductStackTile({
  layer,
}: {
  layer: number;
}) {
  const meshRotation = useRef(0);
  const meshRef = useRef<null | Mesh>(null);
  const meshPosition = new Vector3(2.5, -0.75 + 1.5 * layer, 0);

  useFrame(function (state, delta) {
    if (meshRef.current) {
      meshRotation.current -= 0.1 * delta;
      meshRef.current.rotation.y = meshRotation.current;
    }
  });

  return (
    <mesh position={meshPosition} ref={meshRef}>
      <boxGeometry args={[6, 0.25, 6]} />
      <meshPhysicalMaterial color="#333" wireframe />
    </mesh>
  );
});
